
import { Course } from '../types';

export const emotional_regulation: Course = {
  id: "emotional_regulation",
  title: "Emotional Regulation",
  description: "Stay calm under the immense pressure of family proceedings.",
  icon: "🧘",
  totalModules: 15,
  modules: {
    1: { id: 1, title: "Slide 1", slides: [{ title: "Slide 1", content: `<div class="flex justify-center"><img src="/images/courses/emotional_regulation/Slide1.PNG" alt="Slide 1" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    2: { id: 2, title: "Slide 2", slides: [{ title: "Slide 2", content: `<div class="flex justify-center"><img src="/images/courses/emotional_regulation/Slide2.PNG" alt="Slide 2" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    3: { id: 3, title: "Slide 3", slides: [{ title: "Slide 3", content: `<div class="flex justify-center"><img src="/images/courses/emotional_regulation/Slide3.PNG" alt="Slide 3" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    4: { id: 4, title: "Slide 4", slides: [{ title: "Slide 4", content: `<div class="flex justify-center"><img src="/images/courses/emotional_regulation/Slide4.PNG" alt="Slide 4" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    5: { id: 5, title: "Slide 5", slides: [{ title: "Slide 5", content: `<div class="flex justify-center"><img src="/images/courses/emotional_regulation/Slide5.PNG" alt="Slide 5" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    6: { id: 6, title: "Slide 6", slides: [{ title: "Slide 6", content: `<div class="flex justify-center"><img src="/images/courses/emotional_regulation/Slide6.PNG" alt="Slide 6" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    7: { id: 7, title: "Slide 7", slides: [{ title: "Slide 7", content: `<div class="flex justify-center"><img src="/images/courses/emotional_regulation/Slide7.PNG" alt="Slide 7" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    8: { id: 8, title: "Slide 8", slides: [{ title: "Slide 8", content: `<div class="flex justify-center"><img src="/images/courses/emotional_regulation/Slide8.PNG" alt="Slide 8" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    9: { id: 9, title: "Slide 9", slides: [{ title: "Slide 9", content: `<div class="flex justify-center"><img src="/images/courses/emotional_regulation/Slide9.PNG" alt="Slide 9" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    10: { id: 10, title: "Slide 10", slides: [{ title: "Slide 10", content: `<div class="flex justify-center"><img src="/images/courses/emotional_regulation/Slide10.PNG" alt="Slide 10" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    11: { id: 11, title: "Slide 11", slides: [{ title: "Slide 11", content: `<div class="flex justify-center"><img src="/images/courses/emotional_regulation/Slide11.PNG" alt="Slide 11" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    12: { id: 12, title: "Slide 12", slides: [{ title: "Slide 12", content: `<div class="flex justify-center"><img src="/images/courses/emotional_regulation/Slide12.PNG" alt="Slide 12" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    13: { id: 13, title: "Slide 13", slides: [{ title: "Slide 13", content: `<div class="flex justify-center"><img src="/images/courses/emotional_regulation/Slide13.PNG" alt="Slide 13" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    14: { id: 14, title: "Slide 14", slides: [{ title: "Slide 14", content: `<div class="flex justify-center"><img src="/images/courses/emotional_regulation/Slide14.PNG" alt="Slide 14" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    15: { id: 15, title: "Slide 15", slides: [{ title: "Slide 15", content: `<div class="flex justify-center"><img src="/images/courses/emotional_regulation/Slide15.PNG" alt="Slide 15" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] }
  },
  quiz: [
    {
        "q": "What is identified as your greatest strategic advantage in family court?",
        "o": [
            "Superior legal representation",
            "Extensive documentation",
            "Emotional regulation",
            "Financial resources"
        ],
        "a": 2
    },
    {
        "q": "According to the slides, what are the early warning signs of 'The Red Mist,' a biological survival instinct triggered by conflict?",
        "o": [
            "Increased appetite and drowsiness",
            "Racing heart, sweating, and shallow breathing",
            "A sudden urge to apologize",
            "Feelings of euphoria and excitement"
        ],
        "a": 1
    },
    {
        "q": "Which technique is recommended to manually override the panic center of the brain and return to logical thinking?",
        "o": [
            "The 10-Year Test",
            "The Gray Rock Method",
            "The 24-Hour Rule",
            "Box Breathing (4-4-4-4 cycle)"
        ],
        "a": 3
    },
    {
        "q": "What is the primary goal of the 'Gray Rock Method' when dealing with high-conflict individuals?",
        "o": [
            "To provoke a stronger emotional reaction",
            "To become as uninteresting and boring as possible",
            "To extensively defend yourself against false claims",
            "To meticulously document their hypocrisy"
        ],
        "a": 1
    },
    {
        "q": "Why is maintaining a calm demeanor, also known as 'Courtroom Zen,' important in a courtroom setting?",
        "o": [
            "It ensures the judge will always rule in your favor.",
            "It allows you to present new evidence without objection.",
            "Your physical reaction is weighed as hard evidence by judges.",
            "It guarantees a faster resolution to the case."
        ],
        "a": 2
    }
]
};
